const CONFIDENCE_SCORE = 0.95;
export { CONFIDENCE_SCORE };
